export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "noaddress", name: "NO ADDRESS" },
  { id: "dns2", name: "DNS2 UNAVAILABLE" },
  { id: "aborted", name: "ABORTED" },
  { id: "unlicenced", name: "UNLICENCED" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "badargs", name: "BAD ARGS" },
  { id: "sendfailed", name: "SEND FAILED" },
  { id: "networkunreachable", name: "NETWORK UNREACHABLE" },
  { id: "responsetimeouts", name: "RESPONSE TIMEOUTS" },
  { id: "noresponse", name: "NO RESPONSE" },
  { id: "unknownhost", name: "UNKNOWN HOST" },
  { id: "unknownaddresstype", name: "UNKNOWN ADDRESS TYPE" },
  { id: "passed2", name: "PASSED" },
  { id: "failed2", name: "FAILED" }
];



// WEBPACK FOOTER //
// ./src/components/common/results/views/ping/infoenum.js